import React from 'react';

import {useI18n} from '@udemy/i18n';

import {AccountBalanceSection} from '../../components/payout-report/account-balance-section';
import {HelperLinksSection} from '../../components/payout-report/helper-links-section';
import {PayoutHistorySection} from '../../components/payout-report/payout-history-section';
import {WarningSection} from '../../components/payout-report/warning-section';
import styles from './payout-report-page.module.less';

export const PayoutReportFeature = () => {
    const {gettext} = useI18n();

    return (
        <div>
            <br />
            <div className={styles['main-title']}>
                <h1 className="ud-heading-serif-xxl" style={{paddingRight: 10}}>
                    {gettext('Payout Report')}
                </h1>
            </div>

            <div className="ud-container">
                <HelperLinksSection />
                <WarningSection />
            </div>

            <div className="ud-container">
                <div className={styles['container']}>
                    <AccountBalanceSection />
                    <PayoutHistorySection />
                </div>
            </div>
        </div>
    );
};
